import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=559f4886&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=559f4886&prod&lang=scss&scoped=true"
import style1 from "./OrderList.vue?vue&type=style&index=1&id=559f4886&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559f4886",
  null
  
)

/* custom blocks */
import block0 from "./OrderList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "@/locales2/share/datetime.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fusr%2Fsrc%2Fapp%2Fsrc%2Fonwheel%2Fpages%2FOrderList.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports